import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import AddProduct from '../views/AddProduct.vue'
import EditProduct from '../views/EditProduct.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      requiresAuth:false
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta:{
      requiresAuth:false
    },
  },
  {
    path: '/add',
    name: 'AddProduct',
    component: AddProduct,
    meta:{
      requiresAuth:true
    },
  },
  {
    path: '/edit',
    name: 'EditProduct',
    component: EditProduct,
    meta:{
      requiresAuth:true
    },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async(to, from, next)=>{
    await store.dispatch("verifyAuth")
    let isAuth = store.state.isAuth;
    if(to.name === 'Login' && isAuth){
      next({name:"Home"})
    }
    else if(to.meta.requiresAuth && isAuth){
      next()
    }
    else if(to.meta.requiresAuth === false){
      next()
    }
    else if(to.meta.requiresAuth && isAuth === false){
      next({name:"Home"})
    }
})

export default router
